import { ReactNode } from "react";
import { createPortal } from "react-dom";

import { useIsClientSide } from "@/utils/hooks/isClient.hook";

type Props = {
    target?: Element | DocumentFragment | null;
    children: ReactNode;
};

export const Portal = ({ target, children }: Props) => {
    const isClient = useIsClientSide();

    if (!isClient) return null;

    return createPortal(children, target ?? document.body);
};
